import moment from 'moment'

export function getDateRange(
  startDate: moment.Moment,
  endDate: moment.Moment
): Array<moment.Moment> {
  const diff = endDate.diff(startDate, 'days')
  const range = new Array<moment.Moment>()
  for (let i = 0; i < diff; i++) {
    const date = startDate.clone().add(i, 'days')
    range.push(date)
  }
  return range
}
